<!-- Header-level error: wrong file / wrong column count / wrong column names -->
<div *ngIf="headerErrors && headerErrors.length > 0" class="alert alert-danger mb-0" role="alert">
  <strong>&#9888; File structure error</strong>
  <ul class="mb-0 mt-1 ps-3">
    <li *ngFor="let msg of headerErrors">{{ msg }}</li>
  </ul>
</div>

<!-- Row-level validation errors -->
<div *ngIf="headerErrors.length === 0" class="table-wrapper-scroll-y my-custom-scrollbar">
  <table class="table table-bordered table-striped mb-0">
    <thead>
      <tr>
        <th>Row Index</th>
        <th *ngFor="let col of columns">{{ col }}</th>
        <th>Error Info</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let rowError of data">
        <td>{{ rowError.RowIndex }}</td>

        <td *ngFor="let col of columns"
            [ngClass]="{'table-danger': isColumnError(rowError, col)}"
            style="min-width: 100px; max-width: 300px; width: 150px;">
          {{ rowError.Row[col] !== null && rowError.Row[col] !== undefined ? rowError.Row[col] : '-' }}
        </td>

        <td style="min-width: 300px; max-width: 600px; white-space: normal; word-wrap: break-word;"
            [innerHTML]="getFormattedErrors(rowError)">
        </td>
      </tr>
    </tbody>
  </table>
</div>
